function onloadTurnstile() {
    let turnstiles = document.querySelectorAll(".cf-turnstile");

    turnstiles.forEach(function (turn) {
        const sitekey = turn.dataset.sitekey;
        let form_submit = turn.closest("form").querySelector("button[type=submit]");
        if (!form_submit) {
            return;
        }
        form_submit.disabled = true;
        turnstile.render(turn, {
            sitekey: sitekey,
            callback: function (token) {
                form_submit.disabled = false;
            },
            "expired-callback": function () {
                form_submit.disabled = true;
            },
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    onloadTurnstile();
});
